type Page<T>={data:T[]|null;count:number|null;error:{message:string}|null};
/** Exact counts, stable ID order and unique IDs prevent silently capped totals. */
export async function completePages<T extends {id:string}>(fetchPage:(start:number,end:number)=>PromiseLike<Page<T>>) {
  const all:T[]=[];let expected:number|null=null;
  for(let start=0;start<100000;start+=1000) {
    const result=await fetchPage(start,start+999);
    if(result.error)throw new Error(result.error.message);
    if(result.count===null||result.data===null)throw new Error('Completeness could not be verified.');
    if(expected!==null&&expected!==result.count)throw new Error('Records changed during loading. Please retry.');
    expected=result.count;all.push(...result.data);
    if(all.length===expected){if(new Set(all.map(r=>r.id)).size!==all.length)throw new Error('Duplicate records in response. Please retry.');return all;}
    if(result.data.length!==1000||all.length>expected)throw new Error('Only part of the records arrived. Please retry.');
  }
  throw new Error('Too many records for this planning view.');
}

